import { render } from "./ProfileFiles.vue?vue&type=template&id=17695471&scoped=true"
import script from "./ProfileFiles.vue?vue&type=script&lang=js"
export * from "./ProfileFiles.vue?vue&type=script&lang=js"

import "./ProfileFiles.vue?vue&type=style&index=0&id=17695471&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-17695471"

export default script